import { MessageSquare, Phone } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const PHONE = "+19703156500";

export default function ContactButtons({ className = "", align = "center" }) {
  const isLeft = align === "left";
  return (
    <div className={className}>
      <p className={`text-zinc-400 text-sm font-light ${isLeft ? "text-left" : "text-center"}`}>
        Contact us directly by texting (preferred method) or calling.
      </p>
      <div className={`flex items-center gap-3 mt-3 ${isLeft ? "justify-start" : "justify-center"}`}>
        <a
          href={`sms:${PHONE}`}
          onClick={() => trackEvent("sms_click", { source: "contact_buttons" })}
          data-testid="contact-text-btn"
          className="inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-black font-bold hover:bg-[#E0BC4A] transition-colors rounded-sm px-[3px] py-[1px] text-base tracking-wide shadow-lg"
        >
          <MessageSquare size={18} strokeWidth={2.2} /> Text Us
        </a>
        <a
          href={`tel:${PHONE}`}
          onClick={() => trackEvent("phone_click", { source: "contact_buttons" })}
          data-testid="contact-call-btn"
          className="inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-black font-bold hover:bg-[#E0BC4A] transition-colors rounded-sm px-[3px] py-[1px] text-base tracking-wide shadow-lg"
        >
          <Phone size={18} strokeWidth={2.2} /> Call Us
        </a>
      </div>
    </div>
  );
}
